import type { GetStaticProps } from 'next'
import type { FC } from 'react'
import type { Category } from '@/types'

import { Seo } from '@/components/generals/seo'
import { SiteLayout } from '@/components/layout/site-layout'
import { GoldCta } from '@/components/products'

import { getLayoutData } from '@/lib/layout-data'

interface ShippingProps {
    categories: Category[]
}

const DESCRIPTION =
    "Shipping information for your Milano orders, including our return policy and how to get in touch."

const Shipping: FC<ShippingProps> = ({ categories }) => {
    return (
        <SiteLayout categories={categories}>
            <Seo title='Shipping Information' description={DESCRIPTION} />

            <div className='section relative'>
                <div className='simple-heading-holder'>
                    <div className='container guarantee'>
                        <div className='animation-on-load-01'>
                            <h2 className='white-text'>Shipping Informartion</h2>
                        </div>
                    </div>
                </div>
                <div className='background-image-holder'>
                    <img
                        src='/images/Shipping-Image.webp'
                        loading='lazy'
                        srcSet='/images/Shipping-Image-p-500.jpg 500w, /images/Shipping-Image-p-800.jpg 800w, /images/Shipping-Image-p-1080.jpg 1080w, /images/Shipping-Image.webp 1440w'
                        alt=''
                        sizes='100vw'
                        className='background-image'
                    />
                    <div className='overlay light'></div>
                </div>
            </div>

            <div className='section'>
                <div className='container _6ems'>
                    <div className='w-layout-grid grid-6-col'>
                        <div id='w-node-f5f91031-c4eb-8d89-550c-bd7f1cb6d479-c80e88ef' className='fade-in-move-on-scroll'>
                            <div className='w-richtext'>
                                <h3>Return Policy</h3>
                                <p>The rich text element allows you to create and format headings, paragraphs, blockquotes, images, and video all in one place instead of having to add and format them individually. Just double-click and easily create content.</p>
                                <p>‍</p>
                                <h4>Static and dynamic content editing</h4>
                                <p>‍</p>
                                <p>A rich text element can be used with static or dynamic content. For static content, just drop it into any page and begin editing. For dynamic content, add a rich text field to any collection and then connect a rich text element to that field in the settings panel. Voila!</p>
                                <p>‍</p>
                                <h4>How to customize formatting for each rich text</h4>
                                <p>‍</p>
                                <p>Headings, paragraphs, blockquotes, figures, images, and figure captions can all be styled after a class is added to the rich text element using the &quot;When inside of&quot; nested selector system.</p>
                                <p>‍</p>
                                <ul role='list'>
                                    <li>Products damaged by misuse, abuse, improper care or negligence, or accidents (including pet damage)\</li>
                                    <li>Products showing excessive wear and tear</li>
                                    <li>Products lost or damaged due to fire, flood, or natural disaster</li>
                                    <li>Products with a missing label or label that has been defaced</li>
                                    <li>Products returned for personal reasons unrelated to product performance or satisfaction</li>
                                    <li>Products that have been soiled or contaminated, until they have been properly cleaned</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='section'>
                <div className='divider'></div>
                <div className='container _6ems'>
                    <div className='w-layout-grid grid-6-col'>
                        <div id='w-node-_6ff6a613-9f43-4c5b-3a39-57ff4244a3e6-c80e88ef' className='contact-card-container slide-in-bottom'>
                            <div className='contact-icon-container'>
                                <img src='/images/Email-Icon---Gold.svg' loading='lazy' alt='' className='_100width' />
                            </div>
                            <h4>E-mail</h4>
                            <p className='paragraph-m grey-text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            <a href='mailto:milano@address.com' className='simple-link'>milano@address.com</a>
                        </div>
                        <div id='w-node-_6ff6a613-9f43-4c5b-3a39-57ff4244a3ef-c80e88ef' className='contact-card-container slide-in-bottom'>
                            <div className='contact-icon-container'>
                                <img src='/images/Phone-Icon.svg' loading='lazy' alt='' className='_100width' />
                            </div>
                            <h4>Phone</h4>
                            <p className='paragraph-m grey-text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            <a href='tel:+383(0)49123456' className='simple-link'>+383 (0) 49 123 456</a>
                        </div>
                        <div id='w-node-_6ff6a613-9f43-4c5b-3a39-57ff4244a3f8-c80e88ef' className='contact-card-container slide-in-bottom'>
                            <div className='contact-icon-container'>
                                <img src='/images/Map-Pin-Golden-Icon.svg' loading='lazy' alt='' className='_100width' />
                            </div>
                            <h4>Our Head Office</h4>
                            <p className='paragraph-m grey-text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            <a href='https://maps.google.com/' target='_blank' className='simple-link'>2972 Westheimer Rd. Santa Ana, Illinois 85486</a>
                        </div>
                    </div>
                </div>
            </div>

            <GoldCta />
        </SiteLayout>
    )
}

export const getStaticProps: GetStaticProps<ShippingProps> = async () => {
    const { categories } = getLayoutData()

    return {
        props: {
            categories
        }
    }
}

export default Shipping
